module.exports = __webpack_public_path__ + "img/icon-green.0099f8a8.png";